export default __webpack_public_path__ + "assets/fd90e150d74916575716ebad1c5bcf65.svg";